import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TAny } from '../models/common.type';
import { IResponse } from '../models/response.model';
import { AppConfiguration } from './app-config.service';
import { AbstractHttpBaseService } from './http-base.service';
import { LoggerService } from './logger.service';

@Injectable({ providedIn: 'root' })
export class FileHelperService extends AbstractHttpBaseService {
  constructor(http: HttpClient, appConfig: AppConfiguration, private logService: LoggerService) {
    super(http, appConfig);
  }

  // existing method (kept)
  public getBlogData(path: string, queryParams: {} = {}, type: number = 0) {
    return type === 0
      ? this.get<Blob>(path, { params: { ...queryParams }, responseType: 'blob' })
      : this.get<Blob>(path, { params: { ...queryParams }, responseType: 'blob' as 'json' });
  }

  // ✅ alias with the clearer name used by the component
  public getBlobData(path: string, queryParams: {} = {}, type: number = 0) {
    return this.getBlogData(path, queryParams, type);
  }

  protected override handleError(data: IResponse<TAny>): void {
    this.logService.print('error', data);
  }
}
